import Enhancer from '../enhancer';
import EnhancerApp from '../enhancer-app';
import { getNextArrayVal, getPrevArrayVal, getLastArrayVal } from '../utils/array';
import { addEventListener } from '../utils/dom';

export default class Quiz extends Enhancer {

    init() {

        if (this.activePanel == null) {
            this.panels[0].classList.add("quiz-panel-active");
        }

        this.setButtonState();
        this.bindEvents();
    }

    bindEvents() {
        this.element.querySelector(".quiz-next-btn").addEventListener("click", this.showNextPanel.bind(this));
        this.element.querySelector(".quiz-previous-btn").addEventListener("click", this.showPreviousPanel.bind(this));
        addEventListener(this.element.querySelectorAll("input[type=checkbox]"), "click", this.selectAnswer.bind(this));
    }

    showNextPanel() {

        if (this.activePanel.querySelector("input:checked") == null) {
            return;
        }

        if (this.activePanel == getLastArrayVal(this.questions)) {
            this.element.querySelector(".quiz-end-text .quiz-panel-heading").innerText =
                this.element.dataset.completedHeading.replace("{correctAnswers}", this.correctAnswers.length)
                    .replace("{totalQuestions}", this.questions.length);
                /*`Du fick ${this.correctAnswers.length} av ${this.questions.length} rätt!`;*/
        }

        const nextPanel = getNextArrayVal(this.panels, this.activePanel);

        if (nextPanel != null) {
            this.activePanel.classList.remove("quiz-panel-active");
            nextPanel.classList.add("quiz-panel-active");
            this.setButtonState();
            this.pageFocus();
        }

    }

    showPreviousPanel() {
        const prevPanel = getPrevArrayVal(this.panels, this.activePanel);

        if (prevPanel != null) {
            this.activePanel.classList.remove("quiz-panel-active");
            prevPanel.classList.add("quiz-panel-active");
            this.setButtonState();
            this.pageFocus();
        }
    }

    selectAnswer(e) {
        const clickedElement = e.target;

        if (clickedElement.readOnly) {
            e.preventDefault();
            return;
        }

        const questionInputs = this.activePanel.querySelectorAll('input[type=checkbox]');

        questionInputs.forEach((element) => {
            element.readOnly = true;
        });

        if (clickedElement.dataset.iscorrect == "True") {
            clickedElement.closest(".quiz-answer").classList.add('quiz-answer-correct');
        }
        else {
            clickedElement.closest(".quiz-answer").classList.add('quiz-answer-incorrect');
            Array.from(this.activePanel.querySelectorAll("input[data-iscorrect=True]"))
                .map((element) => { return element.closest(".quiz-answer"); })
                .forEach((element) => { element.classList.add("quiz-answer-correct"); });
        }

        this.activePanel.querySelector(".quiz-explanatory-text").classList.remove("d-none");
    }

    setButtonState() {
        if (this.currentPanelIndex == 0) {
            this.previousQuestionButton.classList.add("d-none");
        }
        else {
            this.previousQuestionButton.classList.remove("d-none");
        }

        if (this.currentPanelIndex < this.questions.length - 1) {
            this.nextQuestionButton.innerText = this.nextQuestionButton.dataset.nextButton;
            this.nextQuestionButton.classList.remove("d-none");
        }
        else if (this.currentPanelIndex == this.questions.length - 1) {
            this.nextQuestionButton.innerText = this.nextQuestionButton.dataset.finishtext;
            this.nextQuestionButton.classList.remove("d-none");
        }
        else if (this.currentPanelIndex > this.questions.length - 1) {
            this.nextQuestionButton.classList.add("d-none");
        }
    }

    pageFocus() {
        var question = this.activePanel.querySelector(".quiz-panel-heading");
        question.focus();
    }

    get correctAnswers() {
        const correctAnswers = this.element.querySelectorAll("input[data-iscorrect=True]:checked");
        return correctAnswers;
    }

    get currentPanelIndex() {
        return this.panels.indexOf(this.activePanel);
    }

    get activePanel() {
        return this.element.querySelector('.quiz-panel-active');
    }

    get panels() {
        return Array.from(this.element.querySelectorAll(".quiz-panel"));
    }

    get questions() {
        return Array.from(this.element.querySelectorAll(".quiz-question"));
    }

    get nextQuestionButton() {
        return this.element.querySelector(".quiz-next-btn");
    }

    get previousQuestionButton() {
        return this.element.querySelector(".quiz-previous-btn");
    }

}

EnhancerApp.register('Quiz', Quiz);